import ButtonPrimary from 'components/ButtonPrimary'
import ContentBox from 'components/ContentBox'
import GymaholicFitnessAppTitle from 'components/GymaholicFitnessAppTitle'
import PageTitle from 'components/Page/Page.Title.js'
import TextTitleLight from 'components/TextTitleLight'
import { View } from 'components/View'
import formatMessageIntlUtil from 'modules/intl/utils/format-message'
import { STYLES_MARGIN } from 'modules/styles/constants/index.cjs'
import React from 'react'
import { defineMessages } from 'react-intl'
import useIntl from 'modules/component/utils/hooks/useIntl'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'
import { logEventAnalyticsUtil } from 'modules/analytics/utils/log-event/index.js'
import { hasHeaderBannerSelect } from 'modules/headerBanner/selectors/hasHeaderBanner/index.js'
import { getAppPathSelect } from 'modules/training/modules/app/selectors/getAppUrl/index.js'

const messages = defineMessages({
  title: {
    id: 'Announcement.title',
    defaultMessage: 'Gymaholic App'
  },
  description: {
    id: 'Announcement.description',
    defaultMessage: 'Achieve your goals by logging meals in seconds and training with personalized workout plans.'
  },
  getStarted: {
    id: 'Announcement.getStarted',
    defaultMessage: 'Get Started'
  }
})

const ANALYTIC_EVENT = {
  GET_STARTED_WITH_APP: 'GET_STARTED_WITH_APP'
}

export default function Announcement ({ location }) {
  const intl = useIntl()
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const hasHeaderBanner = useSelector(hasHeaderBannerSelect)
  const appPath = useSelector(getAppPathSelect)
  if (location.pathname !== '/') {
    return <div />
  }

  const handleClick = () => {
    logEventAnalyticsUtil(ANALYTIC_EVENT.GET_STARTED_WITH_APP)
  }

  let margin
  if (isSmallScreen && hasHeaderBanner) {
    margin = `${STYLES_MARGIN.BIGGEST} 0 0`
  } else if (isSmallScreen && !hasHeaderBanner) {
    margin = `${STYLES_MARGIN.MEDIUM} 0 0`
  } else if (hasHeaderBanner && !isSmallScreen) {
    margin = `${STYLES_MARGIN.BIGGEST} ${STYLES_MARGIN.MEDIUM} 0`
  } else if (!hasHeaderBanner && !isSmallScreen) {
    margin = `${STYLES_MARGIN.MEDIUM} ${STYLES_MARGIN.MEDIUM} 0`
  }

  return (
    <section
      style={{
        margin
      }}
    >
      <ContentBox
        py
        px={isSmallScreen ? 3 : 1}
        style={{
          marginBottom: 0,
          flexDirection: isSmallScreen
            ? View.DIRECTION.COLUMN
            : View.DIRECTION.ROW
        }}
      >
        <View
          style={{
            justifyContent: View.JUSTIFY.CENTER,
            flexGrow: isSmallScreen
              ? undefined
              : 1,
            alignItems: isSmallScreen
              ? View.ALIGN.CENTER
              : View.ALIGN.START,
            textAlign: isSmallScreen
              ? 'center'
              : 'left'
          }}
        >
          <PageTitle>
            <GymaholicFitnessAppTitle />
          </PageTitle>
          <TextTitleLight>
            {formatMessageIntlUtil(intl, messages.description)}
          </TextTitleLight>
          <ButtonPrimary
            name='Get Started with the Gymaholic App'
            onClick={handleClick}
            url={appPath}
            style={{
              margin: `${STYLES_MARGIN.SMALL} auto`,
              width: isSmallScreen
                ? '100%'
                : undefined
            }}
          >
            {formatMessageIntlUtil(intl, messages.getStarted)}
          </ButtonPrimary>
        </View>
      </ContentBox>
    </section>
  )
}
